wbApp.controller('BankSelectionDialogCtrl', ['$scope', '$modal', 'accountingBookSvc',
function ($scope, $modal, accountingBookSvc) {

    $scope.modelOrig = angular.copy($scope.model);
    
    $scope.institutions = accountingBookSvc.getInstitutions();
    $scope.selectedInstitution = {
        id: null
    };
    
    
    $scope.onInstitutionConnect = function () {
        $scope.onInstitutionSelected($scope.selectedInstitution);
        $scope.$hide();
    }
    
    $scope.selectInstitution = function (institution) {
        $scope.selectedInstitution = institution;
    }
    
    $scope.isInstitutionSelected = function () {
        return !!$scope.selectedInstitution.id;
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function() {
        return true;
    }
}]);
